<template>
  <router-link :to="{ query: queryBuilder }"> {{ content.label }}</router-link>
</template>
<script>
import contentBuilder from "@/mixins/contentBuilder";

export default {
  props: ["level"],
  mixins: [contentBuilder],
};
</script>
